import { ObjetKStatusCode } from '@siclop/kstone-vue'
import type { SalaryGridLevel } from './SalaryGridLevel'

export class SalaryGrid extends ObjetKStatusCode {
  professionId?: number
  effectiveDate: string = ''
  description: string = ''
  levels: SalaryGridLevel[] = []

  constructor(data?: Partial<SalaryGrid>) {
    super(data)
    if (data) {
      this.professionId = data.professionId
      this.effectiveDate = data.effectiveDate ?? ''
      this.description = data.description ?? ''
      this.levels = data.levels ?? []
    }
  }
}
